import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import AdminHeader from '../AdminHeader.js';
import { GET_SINGLE_ORDER } from '../../graphql/Mutation/SameDayOrder.js';
import { GET_REFUND_STATUS } from '../../graphql/Query/paymentRefund.js';
import useScrollToTop from '../../components/useScrollToTop.js';
import moment from 'moment'
import { GoCircle } from 'react-icons/go';
import { SlLocationPin } from 'react-icons/sl';
import { API_URL } from '../../config.js';
import PriceCalculator from '../../DocumentShiping/priceCalculator.js';


const AdminSamedayOrderSingle = () => {
    useScrollToTop();
    const [shipmentData, setShipmentData] = useState();
    const location = useLocation();
    const getId = location?.state?.id;
    // console.log('✌️getId --->', getId);
    const orderId = location?.state?.orderId;
    // console.log('✌️orderId --->', orderId);
    const { data: GetOrderOrder, refetch } = useQuery(GET_SINGLE_ORDER, {
        variables: {
            getOrderforSameDayId: getId,
        }
    });

    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    const { data: GetOrderOrderId } = useQuery(GET_REFUND_STATUS, {
        variables: { orderId: orderId }
    });
    // console.log('✌️GetOrderOrderId --->', GetOrderOrderId);
    useEffect(() => {
        const trackShipment = async () => {
            try {
                const order_id = GetOrderOrder?.getOrderforSameDay?.order_id;
                if (!order_id) return;

                const response = await fetch(`${API_URL}/api/orders/${order_id}`);
                if (!response.ok) {
                    if (response.status === 429) {
                        console.warn('Rate limit reached. Skipping this cycle.');
                        return;
                    }
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                // console.log('✌️data++++', data);

                if (data?.status) {
                    setShipmentData(data);
                }
            } catch (err) {
                // console.log('✌️err --->', err);
            }
        };
        trackShipment();
    }, [GetOrderOrder?.getOrderforSameDay?.order_id]);



    return (
        <div>
            <AdminHeader />
            <div className='mx-auto md:pt-14 pt-9 pb-9 max-w-auto px-6 md:space-y-10 space-y-9 lg:px-8'>
                <p className='text-2xl font-semibold'>Track Shipment Details</p>
                <div className='flex justify-between'>
                    <div className='space-y-2'>
                        <p className='text-sm font-semibold text-gray-500'>Shipment ID : <span>{GetOrderOrder?.getOrderforSameDay?.order_id}</span></p>
                        <p className='text-sm font-semibold text-gray-500'>TRACKING URL: <span><a
                            href={GetOrderOrder?.getOrderforSameDay?.tracking_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 underline"
                        >
                            {GetOrderOrder?.getOrderforSameDay?.tracking_url}
                        </a></span></p>
                        {GetOrderOrder?.getOrderforSameDay?.orderId && <p className='text-sm font-semibold text-gray-500'> cf Shipment No: <span>{GetOrderOrder?.getOrderforSameDay?.orderId}</span></p>}
                        <p className='text-sm text-gray-500'>{moment(GetOrderOrder?.getOrderforSameDay?.createdAt).format('DD/MM/YYYY hh:mm A')}</p>
                    </div>
                </div>
                <div className='grid gap-x-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-9'>
                    <div className='p-5 border border-slate-300 rounded-lg'>
                        <div className='space-y-4'>
                            <p className='text-md font-semibold'>Address Details </p>
                            <div className='flex space-x-4'>
                                <div className='space-y-1 text-gray-400'>
                                    <GoCircle />
                                    <ul className='ms-1.5'>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                    </ul>
                                    <SlLocationPin />
                                </div>
                                <div className='space-y-4'>
                                    <div>
                                        <p className='text-sm font-semibold mb-1'>  {GetOrderOrder?.getOrderforSameDay?.data?.pickup_details?.address?.contact_details?.name} <span className='ms-1 text-gray-400'>(Pickup)</span></p>
                                        <p className='text-sm text-gray-500'> {GetOrderOrder?.getOrderforSameDay?.data?.pickup_details?.address?.street_address1}</p>
                                        <p className='text-sm text-gray-500'>{GetOrderOrder?.getOrderforSameDay?.data?.pickup_details?.address?.contact_details?.phone_number}</p>
                                    </div>
                                    <div>
                                        <p className='text-sm font-semibold mb-1'>
                                            {GetOrderOrder?.getOrderforSameDay?.data?.drop_details?.address?.contact_details?.name}
                                            <span className='ms-1 text-gray-600'>(Delivery)</span>
                                        </p>
                                        <p className='text-sm truncate'>
                                            {GetOrderOrder?.getOrderforSameDay?.data?.drop_details?.address?.street_address1}
                                            {/* <p className='text-sm truncate'> surat. gujrat - 679887</p> */}
                                        </p>
                                        <p className='text-sm text-gray-500 truncate'>
                                            {GetOrderOrder?.getOrderforSameDay?.data?.drop_details?.address?.contact_details?.phone_number}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {GetOrderOrder?.getOrderforSameDay?.driverInfo && (
                        <div className='p-5 border border-slate-300 rounded-lg'>
                            <p className='text-md font-semibold pb-4'>Tracking Information</p>
                            <div className='space-y-2'>

                                <div className='border-t pt-3 space-y-3 '>

                                    <div>
                                        {GetOrderOrder?.getOrderforSameDay?.order_id && <h3> Shipment ID: {GetOrderOrder?.getOrderforSameDay?.order_id}</h3>}
                                        {GetOrderOrder?.getOrderforSameDay?.status && <p>Status: {GetOrderOrder?.getOrderforSameDay?.status}</p>}
                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo && <p>Delivery Partner Mobile No:{GetOrderOrder?.getOrderforSameDay?.driverInfo?.mobile?.mobile_number}</p>}
                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.name && <p>Partner: {GetOrderOrder?.getOrderforSameDay?.driverInfo?.name || 'N/A'}</p>}
                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.vehicle_number && <p>Vehicle: {GetOrderOrder?.getOrderforSameDay?.driverInfo?.vehicle_number || 'N/A'}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='p-5 border border-slate-300 rounded-lg'>
                        <PriceCalculator orderAmount={GetOrderOrder?.getOrderforSameDay?.order_amount} />
                    </div>

                    {/* {shipmentData && shipmentData?.order_id && (
                        <div className='p-5 border border-slate-300 rounded-lg'>
                            <p className='text-md font-semibold pb-4'>Tracking Information</p>
                            <div className='space-y-2'>

                                <div className='border-t pt-3 space-y-3 '>

                                    <div>
                                        {shipmentData?.order_id && <h3>Order ID: {shipmentData?.order_id}</h3>}
                                        {shipmentData?.status && <p>Status: {shipmentData?.status}</p>}
                                        {shipmentData?.partner_info && <p>Delivery Partner Mobile No:{shipmentData?.partner_info?.mobile?.mobile_number}</p>}
                                        {shipmentData?.partner_info?.name && <p>Partner: {shipmentData?.partner_info?.name || 'N/A'}</p>}
                                        {shipmentData?.partner_info?.vehicle_number && <p>Vehicle: {shipmentData?.partner_info?.vehicle_number || 'N/A'}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )} */}

                    {GetOrderOrder?.getOrderforSameDay?.paymentDetails &&
                        <div className='p-5 border border-slate-300 rounded-lg'>
                            {GetOrderOrder?.getOrderforSameDay?.paymentDetails.map((items) => {
                                return (
                                    <>
                                        <p className='text-lg font-semibold pb-4'>Payment Details</p>
                                        <div className='space-y-3'>

                                            <p className='text-md font-semibold'>Payment Method</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Type :</p>
                                                <p className='text-sm'>{items?.payment_group}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Receive :</p>
                                                <p className='text-sm'>{items?.payment_method?.upi?.channel}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>UPI ID :</p>
                                                <p className='text-sm'>{items?.payment_method?.upi?.upi_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Status :</p>
                                                <p className='text-sm'>{items?.payment_status}</p>
                                            </div>


                                            <p className='text-md font-semibold'>Payment Gateway Details</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Shipment ID :</p>
                                                <p className='text-sm'>{items?.payment_gateway_details?.gateway_order_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment ID :</p>
                                                <p className='text-sm'>{items?.payment_gateway_details?.gateway_payment_id}</p>
                                            </div>

                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Amount :</p>
                                                <p className='text-sm'>{items?.payment_amount}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Date :</p>
                                                <p className='text-sm'>{items?.payment_completion_time}</p>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>}
                    {GetOrderOrderId?.getRefundStatus &&
                        <div className='p-5 border border-slate-300 rounded-lg'>
                            {GetOrderOrderId?.getRefundStatus?.map((items) => {
                                return (
                                    <>
                                        <p className='text-lg font-semibold pb-4'>Payment Refund Details</p>
                                        <div className='space-y-3'>

                                            <p className='text-md font-semibold'>Payment Refund Method</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment refund_charge :</p>
                                                <p className='text-sm'>{items?.refund_charge}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>refund_id :</p>
                                                <p className='text-sm'>{items?.refund_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>refund_status :</p>
                                                <p className='text-sm'>{items?.refund_status}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>status_description :</p>
                                                <p className='text-sm'>{items?.status_description}</p>
                                            </div>


                                            <p className='text-md font-semibold'>Payment Gateway Details</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment cf_payment_id :</p>
                                                <p className='text-sm'>{items?.cf_payment_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment cf_refund_id :</p>
                                                <p className='text-sm'>{items?.cf_refund_id}</p>
                                            </div>

                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment refund_amount :</p>
                                                <p className='text-sm'>{items?.refund_amount}</p>
                                            </div> <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment order_id :</p>
                                                <p className='text-sm'>{items?.order_id}</p>
                                            </div>

                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment created_at :</p>
                                                <p className='text-sm'>{items?.created_at}</p>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>}
                </div>
            </div>
        </div >
    )
}

export default AdminSamedayOrderSingle
